// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type RevokeMcpConnectionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type RevokeMcpConnectionMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'revokeMcpConnection'>;

export const RevokeMcpConnectionDocument = /*#__PURE__*/ gql`
    mutation RevokeMcpConnection($id: ID!) {
  revokeMcpConnection(id: $id)
}
    `;
export type RevokeMcpConnectionMutationFn = Apollo.MutationFunction<
  RevokeMcpConnectionMutation,
  RevokeMcpConnectionMutationVariables
>;

/**
 * __useRevokeMcpConnectionMutation__
 *
 * To run a mutation, you first call `useRevokeMcpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMcpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMcpConnectionMutation, { data, loading, error }] = useRevokeMcpConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeMcpConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<RevokeMcpConnectionMutation, RevokeMcpConnectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeMcpConnectionMutation, RevokeMcpConnectionMutationVariables>(
    RevokeMcpConnectionDocument,
    options,
  );
}
export type RevokeMcpConnectionMutationHookResult = ReturnType<typeof useRevokeMcpConnectionMutation>;
export type RevokeMcpConnectionMutationOptions = Apollo.BaseMutationOptions<
  RevokeMcpConnectionMutation,
  RevokeMcpConnectionMutationVariables
>;
